// Hash routes, as the prototype (#dashboard, #people …). A page with unsaved changes sets a
// leave guard; going elsewhere then asks first (prototype go(): "Leave without saving?").
import { createStore, useStoreOf } from './store';

const read = () => (location.hash || '').slice(1) || 'dashboard';
export const route = createStore({ r: read() });
export const useRoute = () => useStoreOf(route).r;

let guard: ((proceed: () => void) => boolean) | null = null;
/** `g(proceed)` returns true when it took over (asked the person); null removes the guard. */
export const setLeaveGuard = (g: typeof guard) => { guard = g; };

export function go(r: string, o: { force?: boolean } = {}) {
  if (!o.force && guard && r !== route.get().r && guard(() => { guard = null; go(r, { force: true }); })) return;
  try { history.replaceState(null, '', '#' + r); } catch { /* sandbox */ }
  route.set({ r });
  window.scrollTo(0, 0);
}
window.addEventListener('hashchange', () => route.set({ r: read() }));
